const threePLFreightCalculator = {
  loading: {
    calculator: false,
  },
  detail: {
    cartonToBeDelivered: 0,
    kegToBeDelivered: 0,
  },
  calculatedData: [],
  dispatchedFrom: constructDispatchedFrom(),
  suburbDetail: {},
  suburbList: [],
  isSuburbButtonLoading: false,
}

const ThreePLFreightCalculatorReducer = function (state = threePLFreightCalculator, action) {
  switch (action.type) {
    case 'UPDATE_3PL_FREIGHT_CALCULATOR_DATA': {
      return {
        ...state,
        detail: {
          ...state.detail,
          [action.key]: action.value,
        },
      }
    }
    case 'CLEAR_3PL_FREIGHT_CALCULATOR_DATA': {
      return {
        ...state,
        detail: {},
      }
    }
    case 'SET_3PL_FREIGHT_CALCULATED_DATA': {
      return {
        ...state,
        calculatedData: action.value,
      }
    }
    case 'TOGGLE_3PL_FREIGHT_CALCULATED_LOADER': {
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_SUBURB_DETAIL': {
      return {
        ...state,
        suburbDetail: action.value,
      }
    }
    case 'UPDATE_SUBURB_LIST': {
      return {
        ...state,
        suburbList: action.value,
      }
    }
    case 'TOGGLE_SUBURB_BUTTON_LOADING': {
      return {
        ...state,
        isSuburbButtonLoading: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default ThreePLFreightCalculatorReducer

function constructDispatchedFrom() {
  return [
    {
      label: 'Melbourne',
      value: 1,
      locationCheck: 'Is3PLMEL',
    },
    {
      label: 'Sydney',
      value: 2,
      locationCheck: 'Is3PLSYD',
    },
    {
      label: 'Adelaide',
      value: 3,
      locationCheck: 'Is3PLADE',
    },
    {
      label: 'Brisbane',
      value: 4,
      locationCheck: 'Is3PLBRIS',
    },
    {
      label: 'Cairns',
      value: 5,
      locationCheck: 'Is3PLCAI',
    },
  ]
}
